module.exports = __webpack_public_path__ + "static/media/chevron-hover.8c958303.svg";